import { reactive } from 'vue';

const eventBus = reactive({
  email: null,
});

export default eventBus;